import { Link } from "react-router";
import { styled } from "styled-components";

import { Image, UITag } from "common/components";

export const SourceImage = styled(Image)`
  width: 70px;
  height: 70px;
  border-radius: 4px;
  margin-right: 1rem;
  object-fit: contain;
`;

export const SourceListItemContainer = styled(Link)<{ $isSelected: boolean }>`
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  border: none;
  background-color: ${({ theme }) => theme.colors.dropdownBackground};
  padding: 20px;
  row-gap: 10px;
  cursor: pointer;
  border-radius: 5px;
  border-style: solid;
  border-width: 2px;
  border-color: ${({ $isSelected, theme }) => ($isSelected ? theme.colors.activeCardBorder : "transparent")};
`;

export const StatusTag = styled.p<{ isActive: boolean }>`
  color: ${({ isActive, theme }) => (isActive ? theme.colors.green : theme.colors.red)};
  margin: 0;
  border: 1px solid ${({ isActive, theme }) => (isActive ? theme.colors.green : theme.colors.red)};
  border-radius: 20px;
  padding: 4px 8px;
  width: fit-content;
  font-size: 12px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const TagContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  flex-wrap: wrap;
`;

export const SourceName = styled.p`
  font-size: 1rem;
  margin: 0;

  color: ${({ theme }) => theme.colors.textBright};
`;

export const SourceTypeTag = styled(UITag)`
  font-size: 0.8rem;
`;
